const STORAGE_KEY = "replyn:pending-organization";

export interface PendingOrganization {
  name: string;
}

/**
 * The business name is asked before the account exists, so it has to survive the
 * Google round-trip (sign-up -> Google -> /auth/sso-callback -> /). That is the
 * same tab, so sessionStorage carries it and expires it on its own.
 *
 * It is only ever an optimisation: if this comes back null - private window,
 * blocked storage, a new tab - the onboarding form asks for the name as before.
 */
export const writePendingOrganization = (value: PendingOrganization): void => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    // Nothing to do - onboarding will ask.
  }
};

export const readPendingOrganization = (): PendingOrganization | null => {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);

    if (!raw) return null;

    const parsed = JSON.parse(raw) as PendingOrganization;

    return parsed.name?.trim() ? parsed : null;
  } catch {
    return null;
  }
};

/** Cleared before the create fires, so a failure can't re-fire it on reload. */
export const clearPendingOrganization = (): void => {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to do - the read above already failed for the same reason.
  }
};
